export default {
    ca: {
        title: 'Eliminar compte',
        message: 'Si eliminies el teu compte perdràs els teus mapes i les teves dades',
        alerta: 'Alerta!',
        esborrar: 'Eliminar',
        messageError: 'No s\'ha pogut eliminar el teu compte',
    },
    es: {
        title: 'Eliminar cuenta',
        message: 'Si eliminas tu cuenta perderás tus mapas y tus datos',
        alerta: 'Alerta!',
        esborrar: 'Eliminar',
        messageError: 'No se ha podido eliminar tu cuenta',
    },
    en: {
        title: 'Delete account',
        message: 'If you delete your account you will lose your maps and data',
        alerta: 'Alert!',
        esborrar: 'Delete',
        messageError: 'Your account could not be deleted',
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/baja-modal/baja-modal-translations.js